import { autoWebViewJs } from '@droid/android';
import { Box, Button } from '@mui/material';

export function TestA11y() {
  function exportNode() {
    const script = `
        com.fanfanlo.droidlib.auto.nodeoverlay.NodeOverlayController.exportPackageDataToJson();
        `;
    autoWebViewJs.callScript(script);
  }
  function renderNodeInfo() {
    const script = `
        com.fanfanlo.droidlib.auto.nodeoverlay.NodeOverlayController.createTaskFromJson();
        `;
    autoWebViewJs.callScript(script);
  }
  return (
    <>
      <Box>
        <Button onClick={exportNode} data-testid="TestA11y__exportButton__01JG2B0064">导出节点</Button>
        <Button onClick={renderNodeInfo} data-testid="TestA11y__renderButton__01JG2B0065">渲染节点信息</Button>
      </Box>
    </>
  );
}
